import React from 'react';
import './LineText.scss';

const LineText = ({ lineText, center }) => {
    return (
        <h5 className={`subheading ${center ? "text-center" : ""}`}>{lineText}</h5>
    );
};

export default LineText;